<template>
    <card-list>
        <subheader-list-item icon="fa-align-left" title="Discount Information"/>

        <container-list-item padded no-border>
            <div class="columns">
                <div class="column">
                    <b-field label="Applies To" label-position="inside">
                        <b-select v-model="discount.applies_to" expanded>
                            <option value="registration">Conference Registration Fee</option>
                            <option value="application">Conference Application Fee</option>
                        </b-select>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Expires" label-position="inside">
                        <b-datetimepicker
                            v-model="discount.expires_at"
                            placeholder="Click to select..."
                            icon="calendar"
                            trap-focus
                            append-to-body>
                        </b-datetimepicker>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column is-4">
                    <b-field label="Discount Code" label-position="inside">
                        <b-input v-model="discount.code" maxlength="20"></b-input>
                    </b-field>
                </div>
                <div class="column">
                    <b-field label="Title" label-position="inside">
                        <b-input v-model="discount.title" maxlength="200"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field label="Discount Type" label-position="inside">
                        <b-select v-model="discount.type" expanded>
                            <option value="amount">Discounted by Dollar Amount</option>
                            <option value="percent">Discounted by Percent Amount</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column is-4">
                    <b-field label="Amount" label-position="inside">
                        <b-input v-model="discount.value" placeholder="0.00"></b-input>
                    </b-field>
                </div>
            </div>
            <div class="columns">
                <div class="column">
                    <b-field><b-switch v-model="discount.is_single_use" true-value="1" false-value="0">Discount Code can only be used once.</b-switch></b-field>
                </div>
            </div>
        </container-list-item>
    </card-list>
</template>

<script>
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import CardListItem from "@/TIER/components/CardListItem";
    import SeparatorListItem from "@/components/common/SeparatorListItem";

    export default {
        name: 'ConfDiscountForm',
        props: {
            discount: {
                type: Object,
                required: true
            },
        },
        components: {SeparatorListItem, CardListItem, ContainerListItem, SubheaderListItem, CardList},
        data: function() {
            return {
                type: null,
                title: null,
                componentSelect: null,
                components: [],
                editorOptions: {}
            };
        },
        computed: {},
        methods: {

        },
        mounted: function() {

        }
    };
</script>
